import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import { getCMASummary } from 'apis/CMASummaryAPI';
import FiltersControls from 'common/FiltersControls/FiltersControls';
import { CMA_SUMMARY_INITIAL_FILTERS } from 'components/CMASummary/constants';
import { areCMASummaryFiltersEqual } from 'components/CMASummary/filterUtils';
import { CMASummaryFilters } from 'components/CMASummary/types';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import CMASummarySaveFilterModal from 'components/View/modals/CMASummarySaveFilterModal';
import { hasPermissionOrAdmin } from 'helpers/permissions';
import { VIEW_PERMISSIONS } from 'permissions/views';
import { useAppSelector } from 'store/hook';

const CMASummaryFiltersControls = () => {
  const { competitorId, setViewFilters, viewFilters } = useCommunityViewContext();
  const { selectedCompany } = useAppSelector((state) => state.global);
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const [openSaveModal, setOpenSaveModal] = useState<boolean>(false);

  const canEditCMA = hasPermissionOrAdmin(currentUser, [VIEW_PERMISSIONS.CMA_SUMMARY.CHANGE]);

  const { data: CMASummary } = useQuery({
    queryKey: ['CMASummary', selectedCompany],
    queryFn: () => {
      const requestCMASummaries = async () => {
        const response = await getCMASummary(selectedCompany!.id);
        if (response?.results?.length) {
          const cmaSummary = response.results[0];
          return cmaSummary;
        }
      };
      return requestCMASummaries();
    },
    enabled: Boolean(selectedCompany?.id),
    refetchOnWindowFocus: false,
  });

  const filters = viewFilters as CMASummaryFilters | undefined;

  const filtersChanged = useMemo(() => {
    if (!filters) {
      return false;
    }

    return !areCMASummaryFiltersEqual(filters, CMA_SUMMARY_INITIAL_FILTERS);
  }, [filters]);

  return (
    <FiltersControls
      modal={
        <CMASummarySaveFilterModal
          CMASummary={CMASummary}
          open={openSaveModal}
          onCancel={() => setOpenSaveModal(false)}
        />
      }
      showSaveFilter={!competitorId && canEditCMA}
      disableReset={!filtersChanged}
      onReset={() => setViewFilters(CMA_SUMMARY_INITIAL_FILTERS)}
      onSaveFilter={() => setOpenSaveModal(true)}
    />
  );
};

export default CMASummaryFiltersControls;
